import { render } from "./Setup.vue?vue&type=template&id=1078372a&scoped=true&ts=true"
import script from "./Setup.vue?vue&type=script&lang=ts"
export * from "./Setup.vue?vue&type=script&lang=ts"

import "./Setup.vue?vue&type=style&index=0&id=1078372a&lang=scss&scoped=true"
import "../styles/native-auth.css?vue&type=style&index=1&id=1078372a&scoped=true&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1078372a"]])

export default __exports__